"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingIndicator = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _spinner = require("../../spinner");
const LoadingIndicator = props => /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
  style: props.getStyles("loadingIndicator", props)
}, props.innerProps), /*#__PURE__*/_react.default.createElement(_spinner.Spinner, {
  size: "small"
}));
exports.LoadingIndicator = LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map